// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import singleBranches from './routes/branches';
import postTypeArchiveKitchen from './routes/our-kitchens';
import singleKitchen from './routes/single-kitchen';
import singleProducts from './routes/single-products';
import ourCustomerKitchens from './routes/customer-kitchen-loop';
import blogBlock from './routes/blog-block';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,

  // Home page
  home,

  //Branch/Showroom
  singleBranches,

  //Kitchens Archive
  singleKitchen,

  //Kitchens Archive
  postTypeArchiveKitchen,

  //Single Product
  singleProducts,

  //Customer Inspiration Loop Block
  ourCustomerKitchens,

  //Blog block
  blogBlock,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
